import { render, staticRenderFns } from "./Autotransporte.vue?vue&type=template&id=3d2c3c77&"
import script from "./Autotransporte.vue?vue&type=script&lang=js&"
export * from "./Autotransporte.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports